import moment from 'moment'

const DDMMYYYYSlashSeparated = (time) => {
  return time ? moment(time).format('DD/MM/YYYY') : ''
}

export { DDMMYYYYSlashSeparated }
